<template>
  <div :style="column.align ? `text-align:${column.align}` : ''">
    <v-menu v-model="menuOpen" :close-on-content-click="false">
      <template v-slot:activator="{ attrs, on }">
        <div v-bind="attrs" v-on="{ ...on, click: () => (menuOpen = true) }">{{showTitle?'Dienst ':''}}{{ absence[column.columnName] }} <v-icon>mdi-eye</v-icon></div>
      </template>

      <duty-parts-view
        v-if="dutySelection && dutySelection.resolvedDutyActivities"
        :dutyNameDetails="absence[column.columnName]"
        :dutySelection="dutySelection"
      ></duty-parts-view>
      <duty-parts-own-data-view
        v-else-if="dutySelection"
        :dutyNameDetails="absence[column.columnName]"
        :dutySelection="dutySelection"
      ></duty-parts-own-data-view>
    </v-menu>
  </div>
</template>
<script>
import DutyPartsView from '@/modules/customerVbzWorksheet/components/DutyPartsView.vue';
import DutyPartsOwnDataView from '@/modules/customerVbzWorksheet/components/DutyPartsOwnDataView.vue';

export default {
  name: 'DutyCellWithDetailView',
  components: { DutyPartsOwnDataView, DutyPartsView },
  props: {
    column: Object,
    absence: Object,
    isAssignedToDifferentView: Boolean,
    showTitle:{type:Boolean,default:false}
  },
  data() {
    return {
      menuOpen: false,
      initialValue: false,
    };
  },
  computed: {
    dutySelection() {
      return this.absence.dutySelection || {};
    },
    //   dutySelection:e.dutySelection,
    resolvedDutyActivities() {
      return this.dutySelection.resolvedDutyActivities;
    },
    selectedDutyParts() {
      return this.dutySelection.selectedDutyParts;
    },
    dutySelectionPart() {
      return this.dutySelection.dutySelectionPart;
    },
  },
  methods: {
    /**
     * Save the text
     * @param {object} args
     */
    saveText(args) {
      this.$emit('inlineChange', args);
      this.menuOpen = false;
    },
    cancelEdit() {
      this.absence[this.column.columnName] = this.initialValue;
      this.menuOpen = false;
    },
  },
};
</script>
